import { render, staticRenderFns } from "./ActionManagementCard.vue?vue&type=template&id=35a1a128&scoped=true&"
import script from "./ActionManagementCard.vue?vue&type=script&lang=js&"
export * from "./ActionManagementCard.vue?vue&type=script&lang=js&"
import style0 from "./ActionManagementCard.vue?vue&type=style&index=0&id=35a1a128&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a1a128",
  null
  
)

export default component.exports